import { toast } from "react-toastify";
import { executeGET, executePost } from "../ServiceMethods";
import { SessionTimeout } from "../ErrorMessages";
import { removeUserCredentials } from "../LocalStorage";

export const SignUP = async (SignUpCredentials, cb) => {
  try {
    const UserSignUp = await executePost(
      "/businessuser/signup",
      SignUpCredentials
    );
    const UserSignUpData = UserSignUp.data ? UserSignUp.data : {};
    return UserSignUpData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};

export const GetCountry = async (cb) => {
  try {
    const GetCountryList = await executeGET("/countrylist");
    const getCountryList = GetCountryList.data ? GetCountryList.data : {};
    return getCountryList;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};

export const GetState = async (data, cb) => {
  try {
    const GetStateList = await executePost("/statelist", data);
    const getStateList = GetStateList.data ? GetStateList.data : {};
    // console.log(getStateList);
    return getStateList;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};

export const GetCity = async (data, cb) => {
  try {
    const GetCityList = await executePost("/citylist", data);
    const getCityList = GetCityList.data ? GetCityList.data : {};
    // console.log(getStateList);
    return getCityList;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};

export const GetBusinessCategory = async (data, cb) => {
  try {
    const Getbusinesscategory = await executePost("/businessCategory", data);
    const getbusinesscategory = Getbusinesscategory.data
      ? Getbusinesscategory.data
      : {};
    // console.log(getStateList);
    return getbusinesscategory;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
